import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { useMemo } from 'react';
import FuseNavBadge from '../../FuseNavBadge';

// Estilo alineado con el wizard: letra blanca y fondo azul clarito (#3B82F6) en hover/activo.
const useStyles = makeStyles(theme => ({
	item: props => ({
		height: 42,
		width: '100%',
		borderRadius: '10px',
		margin: '0 0 4px 0',
		paddingRight: 12,
		paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
		color: '#fff',
		cursor: 'pointer',
		textDecoration: 'none!important',
		transition: 'background-color .2s ease, color .2s ease, border-left-color .2s ease',
		borderLeft: '3px solid transparent',
		'&:hover': {
			color: '#fff !important',
			backgroundColor: '#3B82F6 !important'
		},
		'&.active': {
			color: '#fff !important',
			backgroundColor: '#3B82F6 !important',
			borderLeftColor: '#38BDF8',
			pointerEvents: 'none',
			'& .fuse-list-item-text-primary': {
				color: '#fff !important',
				fontWeight: 700
			},
			'& .fuse-list-item-icon': {
				color: '#fff !important'
			}
		},
		'& .fuse-list-item-icon': {
			marginRight: 12,
			color: '#fff'
		},
		'& .fuse-list-item-text-primary': {
			color: '#fff'
		}
	})
}));

function FuseNavVerticalItem(props) {
	const { item, nestedLevel, onItemClick } = props;
	const classes = useStyles({
		itemPadding: nestedLevel > 0 ? 28 + nestedLevel * 16 : 12
	});

	return useMemo(
		() => (
			<ListItem
				component={NavLinkAdapter}
				to={item.url}
				className={({ isActive }) => clsx('fuse-list-item', classes.item, isActive && 'active')}
				onClick={() => onItemClick?.(item)}
			>
				{item.icon && (
					<FuseSvgIcon className="fuse-list-item-icon text-20 flex-shrink-0" color="action">
						{item.icon}
					</FuseSvgIcon>
				)}

				<ListItemText
					sx={{ marginLeft: "10px" }}
					className="fuse-list-item-text"
					primary={item.title}
					classes={{ primary: 'text-13 font-medium fuse-list-item-text-primary' }}
				/>

				{item.badge && <FuseNavBadge badge={item.badge} />}
			</ListItem>
		),
		[classes.item, item, onItemClick]
	);
}

const NavVerticalItem = FuseNavVerticalItem;

export default NavVerticalItem;
